import { Button, Modal } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

export interface UploadAnnotationOnlyObservationModalProps {
  onCloseRequest: () => void
  onConfirmRequest: () => void
}

export const UploadAnnotationOnlyObservationModal = ({
  onCloseRequest,
  onConfirmRequest,
}: UploadAnnotationOnlyObservationModalProps) => {
  const { t } = useTranslation()

  return (
    <Modal
      size="lg"
      onCloseRequest={(event) => {
        event.stopPropagation()
        onCloseRequest()
      }}
      title={t('Warning: Incompatible Annotation Detected')}
      footer={
        <>
          <Button
            onClick={(event) => {
              event.stopPropagation()
              onCloseRequest()
            }}
            label={t('Abort')}
            type="default"
            buttonType="button"
          />
          <Button
            data-testid="confirmUploadOnlyObservationButton"
            onClick={() => {
              onCloseRequest()
              onConfirmRequest()
            }}
            label={t('Confirm')}
            type="action"
            buttonType="button"
          />
        </>
      }
    >
      {t(
        'The annotations you are trying to import are not compatible with models. Please choose one of the following options:'
      )}
      <ul>
        <li>
          {t("Press 'Confirm' to import the images without annotations.")}
        </li>
        <li>{t("Press 'Abort' to stop the importation process.")}</li>
      </ul>
    </Modal>
  )
}

export default UploadAnnotationOnlyObservationModal
